// extracted by mini-css-extract-plugin
module.exports = {"navbarHeight":"70px","badge":"styles_badge__1NP6d","container":"styles_container__2dfY2"};